<template>
  <div class="form-item group__select">
    <span v-if="title" class="form-item__title">{{ title }}</span>
    <div v-click-outside="close" class="form-item__block">
      <slot></slot>
      <span v-if="error" class="form-item__error">{{ error }}</span>
      <div class="form-item__select select" @click="toggleOpen">
        <input
          class="form-item__input"
          :value="selectedFolder.name ? selectedFolder.name : ''"
          :disabled="true"
          :placeholder="placeholder"
        />
      </div>
      <SlideUpDown class="select__slider" :duration="slideDuration" :active="isOpen">
        <div class="select__field">
          <SelectBlock
            v-for="(field, idx) in fields"
            :key="'field' + idx"
            :data="field"
            :padding-left="15"
            @click="click($event, field)"
          ></SelectBlock>
        </div>
      </SlideUpDown>
      <Icon
        class="select__icon form-item__icon"
        :icon="!icon ? 'arrow-down' : icon"
        :class="{ '-opened-': isOpen }"
        @click="toggleOpen"
      ></Icon>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import SelectBlock from './SelectBlock';

export default {
  name: 'SelectFeed',
  components: {
    SelectBlock,
    SlideUpDown
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    title: {},
    error: {},
    placeholder: {
      type: String,
      default: 'Выберите папку'
    },
    icon: {},
    value: {}
  },
  data() {
    return {
      isOpen: false,
      slideDuration: 200,
      selectData: {},
      selectedFolder: {}
    };
  },
  mounted() {
    this.findResult();
  },
  methods: {
    findResult() {
      if (this.fields.length) {
        let result;

        const findInChildren = item => {
          if (result) {
            return;
          }

          const res = item.find(iItem => iItem.folder.id === this.value);

          if (res) {
            result = res.folder;
          } else {
            item.forEach(iItem => {
              if (iItem.childrenFolders && iItem.childrenFolders.length) {
                findInChildren(iItem.childrenFolders);
              }
            });
          }
        };

        this.fields.forEach(item => {
          if (item.folder.id === this.value) {
            result = item.folder;
          }

          if (!result && item.childrenFolders && item.childrenFolders.length) {
            findInChildren(item.childrenFolders);
          }
        });

        if (result) {
          this.selectedFolder = { ...result };
        }
      }
    },
    toggleOpen() {
      if (this.fields) {
        this.isOpen = !this.isOpen;
      }
    },
    close() {
      this.isOpen = false;
    },
    click(folder) {
      this.selectedFolder = _.cloneDeep(folder);
      this.$emit('input', folder.id);
      this.close();
    }
  }
};
</script>
